/* eslint-disable init-declarations */
import React from 'react';
import { iStreamedResponse } from 'interfaces/iStreamedResponse';
import ReactMarkdown from 'react-markdown';

interface StreamDisplayProps {
  streamData: string[];
  ticket: boolean;
  module?: string;
}

const StreamDisplay: React.FC<StreamDisplayProps> = ({
  streamData,
  ticket,
  module,
}) => {
  return (
    <div
      style={{
        color: 'var(--Text-Main, var(--text-primary))',
        fontSize: '14px',
      }}
    >
      <h3
        className={
          ticket ? 'classify-resp-header-ticket' : 'classify-resp-header'
        }
      >
        Classification Output:
      </h3>
      <div
        style={
          ticket ?
            {
              height: '100%',
              overflowY: 'auto',
              minHeight: `${module === 'ear' ? '650px' : '560px'}`,
            } :
            { height: '560px', overflowY: 'auto' }
        }
      >
        {streamData.length === 0 ? (
          <div className='spinner-spacer-top'>
            <div className='loader'>Loading...</div>
          </div>
        ) : (
          streamData.map((chunk, index) => {
            try {
              const streamedResp: iStreamedResponse = JSON.parse(chunk);
              const { message } = streamedResp;

              return (
                <div key={index} className='classify-results-card'>
                  <div className='classify-results-card-text'>
                    <ReactMarkdown
                      components={{
                        h1: ({ children }: any) => (
                          <h1
                            style={{
                              fontSize: '14px',
                              fontWeight: '600',
                              fontStyle: 'normal',
                            }}
                          >
                            {children}
                          </h1>
                        ),
                        h2: ({ children }: any) => (
                          <h2
                            style={{
                              fontSize: '14px',
                              fontWeight: '600',
                              fontStyle: 'normal',
                            }}
                          >
                            {children}
                          </h2>
                        ),
                        h3: ({ children }: any) => (
                          <h3
                            style={{
                              fontSize: '14px',
                              fontWeight: '600',
                              fontStyle: 'normal',
                            }}
                          >
                            {children}
                          </h3>
                        ),
                        h4: ({ children }: any) => (
                          <h4
                            style={{
                              fontSize: '14px',
                              fontWeight: '600',
                              fontStyle: 'normal',
                            }}
                          >
                            {children}
                          </h4>
                        ),
                        p: ({ children }: any) => (
                          <p
                            style={{
                              fontSize: '14px',
                              fontWeight: '400',
                              fontStyle: 'normal',
                            }}
                          >
                            {children}
                          </p>
                        ),
                      }}
                    >
                      {message.replace(/<\/?i>/g, '')}
                    </ReactMarkdown>
                  </div>
                </div>
              );
            } catch (err) {
              console.warn('Invalid JSON chunk:', chunk, err);
              return (
                <div key={index} className='classify-results-card'>
                  <div className='classify-results-card-text'>
                    <p style={{ color: 'red' }}>⚠️ Invalid response received</p>
                  </div>
                </div>
              );
            }
          })
        )}
      </div>
    </div>
  );
};

export default StreamDisplay;
